import Vue from 'vue'
import Loading from './Loading'

const loading = (overlay,isfull = false) => {
  const Constructor = Vue.extend(Loading) //创建一个alert子实例

  let instance = new Constructor({
    el: document.createElement('div'), //将alert实例挂载到创建的div上
    data() {
      return {
        absolute:!isfull,
        overlay:overlay
      }
    }
  })
  instance.vm = instance.$mount()
  document.getElementById("wjs").appendChild(instance.vm.$el)
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  return instance.vm
}
let vm;
function show(isfull){
  vm = loading(true,isfull);
}

function hide(){
  vm.$el.remove() //再点击关闭得时候要将其移出，（仅在第一种方法中使用）
  vm.$destroy()
}

export default {show,hide}
